export default {"src":"/_next/static/image/public/images/ic_error_white.9aee30e6c02fd81c4d8291ec47a00048.svg","height":18,"width":18};